import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";
import PromptDocumentField from "../components/administration/ai/PromptDocumentField";

// Connects to data-controller="ai-prompt-document"
//
// Mountet das Kontextdokument-Upload-Widget (#4842) in die HAML-Adminmaske und
// synchronisiert die Auswahl in zwei versteckte Form-Felder:
//   fileId-Target  → ai_prompt[document_file_id]  (neue/aktuelle Datei, FS::File-_id)
//   remove-Target  → ai_prompt[remove_document]    ("1" beim Entfernen)
// Vorbild: permission_picker_controller.jsx.
export default class extends Controller {
  static targets = ["fileId", "remove", "mount"];
  static values = {
    filename: String,
    state: String,
    statusUrl: String,
    checkUrl: String,
  };

  connect() {
    this.root = createRoot(this.mountTarget);
    this.render();
  }

  render() {
    this.root.render(
      <QueryClientProvider>
        <PromptDocumentField
          initialFileId={this.fileIdTarget.value || undefined}
          initialFilename={this.filenameValue || undefined}
          initialState={this.stateValue || undefined}
          statusUrl={this.statusUrlValue || undefined}
          checkUrl={this.checkUrlValue || undefined}
          onChange={this.handleChange}
        />
      </QueryClientProvider>,
    );
  }

  handleChange = (fileId) => {
    if (fileId) {
      this.fileIdTarget.value = fileId;
      this.removeTarget.value = "";
    } else {
      this.fileIdTarget.value = "";
      this.removeTarget.value = "1";
    }
  };

  disconnect() {
    this.root?.unmount();
  }
}
